/** angular */
import { Component, Input } from '@angular/core';
import { BydValidation } from './models/byd-validation.model';
/** end angular */

/**
 * Custom input based on Angular material, used to search,
 * This component's width is adaptive through its parent
 *
 * A part of the style is written here: /ds-style-themes.scss
 */
@Component({
  selector: 'byd-validations',
  templateUrl: './byd-validations.component.html',
  styleUrls: ['./byd-validations.component.scss'],
})
export class BydValidationsComponent {
  @Input() public validations: BydValidation[];
}
